// @flow

import type { Tld, Process } from '@gandi/domain-configuration';
import type { TranslatorProps } from '@gandi/translate';

import type { GandiLogger } from 'gandi.redux-logger';

import type { StepStatus, PurchaseGroupId, UIStep, Role } from '../types/index';

export const computeFlag = (uiStep: UIStep): string => {
  const role = uiStep.roles[uiStep.roles.length - 1];
  // $FlowFixMe[incompatible-type]
  return `${uiStep.purchaseGroupId}_${uiStep.domainInfo.tld}_${uiStep.domainInfo.process}_${role.label}`;
};

export const getStepInfo = (
  uiStep: UIStep,
): {
  process: void | Process,
  purchaseGroupId: PurchaseGroupId,
  role: Role,
  status: ?StepStatus,
  tld: Tld,
} => {
  const role = uiStep.roles[uiStep.roles.length - 1];
  return {
    purchaseGroupId: uiStep.purchaseGroupId,
    tld: uiStep.domainInfo.tld,
    process: uiStep.domainInfo.process,
    role: role.label,
    status: role.status,
  };
};

export const sortRolesList = (list: Array<Role>): Array<Role> => {
  const orderType = ['owner', 'admin', 'tech', 'bill'];
  return list.sort((a, b) => orderType.indexOf(a) - orderType.indexOf(b));
};

export const translationsHelper =
  (translator: TranslatorProps, logger: GandiLogger): ((key: string) => any) =>
  (key: string) => {
    const { __ } = translator;
    const mapping = {
      'contact-owner': __('Owner contact'),
      'contact-admin': __('Administrator contact'),
      'contact-tech': __('Technical contact'),
      'contact-bill': __('Billing contact'),
      create: __('Registration'),
      transfer: __('Transfer'),
      change_owner: __('Change Owner'),
    };
    // https://sentry.corp.gandi.net/Gandi/shop/issues/665893/
    // $FlowFixMe[invalid-computed-prop]
    if (!mapping[key]) {
      logger.error(`translationsHelper error key: ${key}`);
    }
    // $FlowFixMe[invalid-computed-prop]
    return mapping[key] || '';
  };
